import apiFetch from '../apiFetch'
export default function (token) {
  return apiFetch({ endPoint: '/FinancingType/List', method: 'GET', body: null, token: token })
}
